import { render } from "./BatchLoaderModalResult.vue?vue&type=template&id=503b62ce&ts=true"
import script from "./BatchLoaderModalResult.vue?vue&type=script&lang=ts"
export * from "./BatchLoaderModalResult.vue?vue&type=script&lang=ts"

import "./BatchLoaderModalResult.vue?vue&type=style&index=0&id=503b62ce&lang=stylus"

import exportComponent from "/tmp/ffsecurity-ui/packages/v2/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__